import { Outlet, useNavigate } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { LoadingScreen } from '../loading/LoadingScreen';
import { useEffect } from 'react';
import { useAuth } from '../../hooks/use-auth';
import { usePageTracking } from '../../hooks/use-analytics';

export function RootLayout() {
  const { loading, user } = useAuth();
  const navigate = useNavigate();
  // Track page views
  usePageTracking();

  // Persist auth state
  useEffect(() => {
    if (!loading && !user) {
      const publicPaths = [
        '/',
        '/signin',
        '/signup',
        '/pricing',
        '/help',
        '/terms',
        '/privacy'
      ];
      if (!publicPaths.includes(window.location.pathname)) {
        navigate('/signin');
      }
    }
  }, [loading, user, navigate]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Navbar />
      <div className="min-h-screen">
        <Outlet />
      </div>
      <Footer />
    </>
  );
}
